import { getElementScroll } from './helpers';

const className = 'scroll-lock';
let scrollTop = 0;

export let scrollLocked = false;
export const enable = enableScrollLock;
export const disable = disableScrollLock;
export const toggle = toggleScrollLock;

export function enableScrollLock() {
    if (!scrollLocked) {
        const scrollPosition = getElementScroll();
        window.scrollTo(scrollPosition.left, 0);

        const htmlTag = document.documentElement;
        htmlTag.classList.add(className);
        htmlTag.style.marginTop = `${-scrollPosition.top}px`;
        htmlTag.style.position = 'fixed';
        htmlTag.style.overflow = 'hidden';
        htmlTag.style.width = '100%';
        document.body.style.overflowY = 'scroll';

        scrollLocked = true;
        scrollTop = scrollPosition.top;
    }
}

export function disableScrollLock() {
    if (scrollLocked) {
        const scrollPosition = getElementScroll();

        const htmlTag = document.documentElement;
        htmlTag.classList.remove(className);
        htmlTag.style.marginTop = '';
        htmlTag.style.position = '';
        htmlTag.style.overflow = '';
        htmlTag.style.width = '';
        document.body.removeAttribute('style');

        window.scrollTo(scrollPosition.left, scrollTop);

        scrollLocked = false;
    }
}

export function toggleScrollLock() {
    if (scrollLocked) {
        disableScrollLock();
    } else {
        enableScrollLock();
    }
}

export default {
    enable,
    disable,
    toggle
};
